var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGfg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300.826,
    height: 39.577,
    viewBox: "0 0 300.826 39.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-3608 -227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(3608 227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M988.871,586.642h-32.7a13.06,13.06,0,0,1,22.949-6.9l4.757-4.783a19.789,19.789,0,0,0-34.466,11.678H949.3a19.789,19.789,0,0,0-34.466-11.678l4.757,4.783a13.06,13.06,0,0,1,22.949,6.9h-32.7q-.057.757-.058,1.529a19.791,19.791,0,0,0,39.055,4.533h1.042a19.789,19.789,0,0,0,39.055-4.533Q988.929,587.4,988.871,586.642Zm-59.305,14.589a13.063,13.063,0,0,1-12.261-8.555h24.522A13.064,13.064,0,0,1,929.565,601.231Zm39.576,0a13.064,13.064,0,0,1-12.262-8.555H981.4A13.063,13.063,0,0,1,969.141,601.231Z",
    transform: "translate(-909.777 -568.383)",
    fill: "#2f8d46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(3703.022 236.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(26.144 4.527)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 1.046,
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(56.695 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1352.9,615.759l-6.714-6.771v6.771h-3.09V594.521h3.09v12.53l6.084-6.056,3.909,0-6.988,6.988,7.67,7.782Z",
    transform: "translate(-1343.095 -594.521)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(113.247 6.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1504.614,627.712V612.948h3.09v2.558a3.7,3.7,0,0,1,1.447-1.91,3.9,3.9,0,0,1,2.262-.73,5.447,5.447,0,0,1,1.208.112l-.7,3a2.449,2.449,0,0,0-.842-.082,3.044,3.044,0,0,0-2.388,1.138,4.676,4.676,0,0,0-.983,3.16v7.515Z",
    transform: "translate(-1504.614 -612.865)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(70.943 6.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1385.943,626.817a5.668,5.668,0,0,1-2.152-2.683l2.669-1.171a3.743,3.743,0,0,0,1.376,1.662,3.657,3.657,0,0,0,2.029.572,4.049,4.049,0,0,0,1.879-.395,1.266,1.266,0,0,0,.763-1.185,1.367,1.367,0,0,0-.654-1.2,6.492,6.492,0,0,0-2.016-.763l-1.662-.409a5.974,5.974,0,0,1-2.752-1.444,3.452,3.452,0,0,1-1.089-2.615,3.4,3.4,0,0,1,.722-2.152,4.647,4.647,0,0,1,1.948-1.43,6.957,6.957,0,0,1,2.67-.5,7.191,7.191,0,0,1,3.405.776,4.6,4.6,0,0,1,2.125,2.247l-2.615,1.144a2.925,2.925,0,0,0-2.888-1.608,3.231,3.231,0,0,0-1.689.409,1.213,1.213,0,0,0-.681,1.063,1.226,1.226,0,0,0,.518,1.021,4.442,4.442,0,0,0,1.526.667l2.043.518a6.573,6.573,0,0,1,3.092,1.566,3.5,3.5,0,0,1,1.049,2.575,3.72,3.72,0,0,1-.749,2.3,4.829,4.829,0,0,1-2.057,1.539,7.44,7.44,0,0,1-2.887.545A6.781,6.781,0,0,1,1385.943,626.817Z",
    transform: "translate(-1383.791 -613.101)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(96.285 6.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1463.543,613.146a7.374,7.374,0,1,0,7.374,7.374A7.374,7.374,0,0,0,1463.543,613.146Zm0,11.532a4.228,4.228,0,1,1,4.228-4.228A4.228,4.228,0,0,1,1463.543,624.678Z",
    transform: "translate(-1456.169 -613.146)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(23.011 6.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1261.615,621.145c.017-.232.027-.466.024-.7a7.292,7.292,0,0,0-.212-1.685,7.375,7.375,0,0,0-14.537,1.84c0,.236.017.47.04.7a7.263,7.263,0,0,0,.673,2.382,7.374,7.374,0,0,0,13.389-.141l-3.267.034a4.617,4.617,0,0,1-8.014-2.3Zm-11.664-2.266a4.614,4.614,0,0,1,8.592-.09Z",
    transform: "translate(-1246.891 -613.144)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(39.461 6.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1308.6,621.145c.017-.232.027-.466.025-.7a7.375,7.375,0,1,0-14.749.155c0,.236.017.47.04.7a7.257,7.257,0,0,0,.672,2.382,7.375,7.375,0,0,0,13.39-.141l-3.268.034a4.616,4.616,0,0,1-8.014-2.3Zm-11.663-2.266a4.614,4.614,0,0,1,8.592-.09Z",
    transform: "translate(-1293.873 -613.144)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(85.044 0.245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1430.636,598.566a2.5,2.5,0,0,1,1.8-.549,4.2,4.2,0,0,1,1.657.281v-2.752a7.24,7.24,0,0,0-2.3-.337,4.82,4.82,0,0,0-3.455,1.278,4.666,4.666,0,0,0-1.349,3.554v1.417h-2.922v2.752h2.922v12.036h3.091V604.209h4.016v-2.752h-4.016V600.4A2.5,2.5,0,0,1,1430.636,598.566Z",
    transform: "translate(-1424.063 -595.209)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1202.443,605.147a10.637,10.637,0,1,1-2.72-7.1l-1.983,1.982a7.837,7.837,0,1,0,1.656,7.09h-6.883v-2.851h9.895Q1202.443,604.7,1202.443,605.147Z",
    transform: "translate(-1181.169 -594.51)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(179.788 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1704.467,615.759l-6.714-6.771v6.771h-3.09V594.521h3.09v12.53l6.084-6.056,3.909,0-6.988,6.988,7.669,7.782Z",
    transform: "translate(-1694.663 -594.521)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(194.036 6.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1737.51,626.817a5.667,5.667,0,0,1-2.152-2.683l2.67-1.171a3.742,3.742,0,0,0,1.375,1.662,3.658,3.658,0,0,0,2.03.572,4.051,4.051,0,0,0,1.88-.395,1.267,1.267,0,0,0,.763-1.185,1.367,1.367,0,0,0-.654-1.2,6.492,6.492,0,0,0-2.016-.763l-1.662-.409a5.974,5.974,0,0,1-2.751-1.444,3.451,3.451,0,0,1-1.09-2.615,3.4,3.4,0,0,1,.722-2.152,4.651,4.651,0,0,1,1.948-1.43,6.96,6.96,0,0,1,2.67-.5,7.191,7.191,0,0,1,3.405.776,4.6,4.6,0,0,1,2.125,2.247l-2.615,1.144a2.926,2.926,0,0,0-2.888-1.608,3.232,3.232,0,0,0-1.689.409,1.214,1.214,0,0,0-.681,1.063,1.227,1.227,0,0,0,.518,1.021,4.443,4.443,0,0,0,1.526.667l2.043.518a6.576,6.576,0,0,1,3.092,1.566,3.5,3.5,0,0,1,1.049,2.575,3.719,3.719,0,0,1-.749,2.3,4.833,4.833,0,0,1-2.057,1.539,7.44,7.44,0,0,1-2.888.545A6.781,6.781,0,0,1,1737.51,626.817Z",
    transform: "translate(-1735.358 -613.101)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(146.104 6.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1613.182,621.145c.017-.232.027-.466.025-.7a7.375,7.375,0,1,0-14.749.155c0,.236.017.47.04.7a7.254,7.254,0,0,0,.673,2.382,7.375,7.375,0,0,0,13.389-.141l-3.268.034a4.616,4.616,0,0,1-8.014-2.3Zm-11.663-2.266a4.615,4.615,0,0,1,8.592-.09Z",
    transform: "translate(-1598.458 -613.144)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(162.554 6.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M1660.165,621.145c.017-.232.027-.466.024-.7a7.375,7.375,0,1,0-14.749.155c0,.236.017.47.04.7a7.266,7.266,0,0,0,.673,2.382,7.375,7.375,0,0,0,13.389-.141l-3.268.034a4.616,4.616,0,0,1-8.014-2.3Zm-11.663-2.266a4.614,4.614,0,0,1,8.592-.09Z",
    transform: "translate(-1645.44 -613.144)",
    fill: "#0f2b3c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(123.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M1554.01,605.147a10.636,10.636,0,1,1-2.72-7.1l-1.983,1.982a7.837,7.837,0,1,0,1.656,7.09h-6.884v-2.851h9.895Q1554.01,604.7,1554.01,605.147Z",
    transform: "translate(-1532.736 -594.51)",
    fill: "#0f2b3c"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfg);
export default __webpack_public_path__ + "static/media/gfg.897c1c30bebfc6595d56842b540eca10.svg";
export { ForwardRef as ReactComponent };